import { getLocale } from "../runtime";

const sv_addedlong = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tillagd till varukorgen`
};

const addedlong = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_addedlong(inputs)
	return "addedLong";
};

export { addedlong as "addedLong" };